var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Shield Done"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shield Done"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shield Done_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5242 38.3489C20.718 38.4502 20.9347 38.5016 21.1514 38.4999C21.3681 38.4982 21.583 38.445 21.7786 38.342L28.0224 35.0043C29.7929 34.0605 31.1795 33.0051 32.2612 31.7764C34.6132 29.0994 35.8976 25.6827 35.8747 22.1596L35.8007 10.5385C35.7936 9.19994 34.9145 8.00557 33.6143 7.57141L21.9988 3.67424C21.2994 3.43742 20.533 3.44257 19.8459 3.68625L8.27443 7.72242C6.98127 8.17374 6.118 9.3767 6.12504 10.7169L6.19904 22.3295C6.22194 25.8577 7.55033 29.2589 9.94108 31.9085C11.0334 33.1201 12.4323 34.16 14.2222 35.0884L20.5242 38.3489ZM18.8713 24.6906C19.132 24.9412 19.4703 25.0647 19.8085 25.0613C20.1468 25.0596 20.4833 24.9326 20.7405 24.6786L27.5639 17.9517C28.0766 17.4454 28.0713 16.632 27.5534 16.1327C27.0337 15.6333 26.1968 15.6367 25.6841 16.1429L19.7892 21.9535L17.3755 19.6334C16.8558 19.134 16.0207 19.1392 15.5063 19.6454C14.9936 20.1517 14.9989 20.9651 15.5186 21.4644L18.8713 24.6906Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIcon2);
export default __webpack_public_path__ + "static/media/hero-icon2.78e831e4784dbc27b789dddcaed47f6d.svg";
export { ForwardRef as ReactComponent };